module.exports = __webpack_public_path__ + "media/eye-contour-serum-small.410e77e3.mp4";